<div ng-controller="readLogReminderController as ctrl" class="modal-view readReminder">
    <header ng-show="!showLabel || showLabel === 'true'">
        <h1>{{'readReminder.messageHeader'|translate}}</h1>
        <p>{{'readReminder.messageDescription'|translate}}</p>
    </header>
    <textarea class="message" name="activityMessage" ng-model="ctrl.message" ng-attr-placeholder="{{'readReminder.messagePlaceholder'|translate}}"></textarea>
</div>